import React, { useRef, useState } from "react";
import { sendContactEmail, validateFormData } from "../utils/emailService";
import Images from "../assets/AllImages";
import { useTranslation } from "react-i18next";
import { useToast } from "../components/Toast";

const CONTACTUS = () => {
  const { t } = useTranslation();
  const { success, error } = useToast();
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

const sendEmail = async (e) => {
  e.preventDefault();
  if (isSubmitting) return;
  if (!form.current) return;

  setIsSubmitting(true);

  const fd = new FormData(form.current);
  const data = {
    user_name:   String(fd.get("user_name")   || "").trim(),
    user_surname:String(fd.get("user_surname")|| "").trim(), // <-- now sent
    user_email:  String(fd.get("user_email")  || "").trim(),
    user_phone:  String(fd.get("user_phone")  || "").trim(),
    message:     String(fd.get("message")     || "").trim(),
  };

  const { isValid, errors } = validateFormData("contact", data);
  if (!isValid) {
    error(t("contact.fixErrors") + "\n" + errors.join("\n"));
    setIsSubmitting(false);
    return;
  }

  try {
    await sendContactEmail(data); // throws on non-2xx or success:false
    setShowSuccess(true);
    form.current.reset();
  } catch (err) {
    error(t("contact.failurePrefix") + " " + (err?.message || t("contact.unknownError")));
    console.error("Contact form error:", err);
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <>
      <main>
        <div className="container-fluid bg-primary py-3 py-md-0">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 px-5">
              <h1 className="text-white fw-bold mb-4 responsive-heading">{t("contact.title")}</h1>
            </div>
            <div className="col-12 col-md-6 px-5 text-end d-none d-sm-block">
              <img src={Images.Vactor2} alt="" className="vector-img" />
            </div>
          </div>
        </div>
      </main>

      {/* Contact Info Section */}
      <div className="container-fluid pt-5">
        <div className="row align-items-center">
          <div className="col-12 col-lg-6 mb-4 px-1 px-lg-5 contact-section">
            {/* <span className="subtitle contact-subtitle">NA KONTAKTONI</span> */}
            <h3 className="text-primary fw-bold contact-heading">
              {t("contact.leadHeadline")}
            </h3>

            <p className="contact-text">
              {t("contact.leadSub1")}
            </p>

            <p className="contact-text">
              {t("contact.leadSub2")}
            </p>
          </div>

          <div className="col-12 col-lg-6 px-0">
            <img src={Images.Contactimg1} alt="" className="img-fluid contact-image" />
          </div>
        </div>
      </div>

      {/* Contact Details Section */}
      <div className="container-fluid ps-lg-5 mb-5 contact-details-section">
        <div className="row">
          <div className="col-12 col-md-8 col-lg-5 bg-light">
            <div className="contact-detail-box mb-4 px-4 px-md-0">
              <a
                href="https://maps.app.goo.gl/fzkR7EcSumteDqMD8"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-box"
                style={{ display: "inline-flex" }}
                aria-label={t("contact.mapAriaLabel")}
              >
                <img src={Images.LocationIcon} alt="" className="icon-img" />
              </a>

              <div className="detail-text">
                <a
                  href="https://maps.app.goo.gl/fzkR7EcSumteDqMD8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="subtitle"
                  style={{ fontSize: "1.1rem", textDecoration: "none" }}
                >
                  {t("contact.stepArena")}
                </a>
              </div>
            </div>

            <div className="contact-detail-box px-4 px-md-0">
              <div className="icon-box">
                <img src={Images.MailIcon} alt="" className="icon-img" />
              </div>
              <div className="detail-text">
                <span className="subtitle" style={{ fontSize: "1.1rem" }}>{t("contact.emailUs")}</span>
                <h6 className="text-primary fw-bold" style={{ fontSize: "1.1rem" }}>
                  <a href="mailto:info@step-ks.com" className="text-primary d-block">info@step-ks.com</a>
                </h6>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 col-lg-3 bg-primary p-4 text-white text-center">
            <img src={Images.CallIcon} alt="" className="mb-4 support-icon" />
            <h6 className="fw-bold" style={{ fontSize: "1.3rem" }}>{t("contact.bookingSupport")}</h6>
            <p style={{ fontSize: "1.1rem" }}>
              {t("contact.phoneLabel")}:{" "}
              <a href="tel:048334000" className="text-light text-decoration-none" style={{ fontSize: "18px" }}>
                048 334 000
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Map + Form Section */}
      <div className="contact-map-form">
        <a
          href="https://maps.app.goo.gl/fzkR7EcSumteDqMD8"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={Images.Map} alt="Map" className="map-image" style={{ cursor: "pointer" }} />
        </a>

        <div className="contact-form-container mx-3 mx-lg-auto">
          <p style={{ fontSize: "1.2rem" }}>
            {t("contact.formIntro")}
          </p>

          <form ref={form} onSubmit={sendEmail} noValidate>
            <fieldset disabled={isSubmitting} style={{ border: 0, padding: 0, margin: 0 }}>
              <div className="row mb-3">
                <div className="col-md-6 mb-3 mb-md-0">
                  <label htmlFor="user_name" className="form-label fw-bold">
                    {t("contact.firstNameLabel")} *
                  </label>
                  <input
                    id="user_name"
                    name="user_name"
                    type="text"
                    className="form-control"
                    placeholder={t("contact.firstNamePlaceholder")}
                    autoComplete="given-name"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="user_surname" className="form-label fw-bold" style={{ fontSize: "1.1rem" }}>
                    {t("contact.lastNameLabel")}
                  </label>
                  <input
                    id="user_surname"
                    name="user_surname"
                    type="text"
                    className="form-control"
                    placeholder={t("contact.lastNamePlaceholder")}
                    autoComplete="family-name"
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6 mb-3 mb-md-0">
                  <label htmlFor="user_email" className="form-label fw-bold">
                    {t("contact.emailLabel")} *
                  </label>
                  <input
                    id="user_email"
                    name="user_email"
                    type="email"
                    className="form-control"
                    placeholder={t("contact.emailPlaceholder")}
                    autoComplete="email"
                    inputMode="email"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="user_phone" className="form-label fw-bold" style={{ fontSize: "1.1rem" }}>
                    {t("contact.phoneLabelFull")}
                  </label>
                  <input
                    id="user_phone"
                    name="user_phone"
                    type="tel"
                    className="form-control"
                    placeholder={t("contact.phonePlaceholder")}
                    autoComplete="tel"
                    inputMode="tel"
                    pattern="^\+?[0-9\s\-()]{6,}$"
                    title="Use digits, spaces, dashes, or parentheses"
                  />
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="message" className="form-label fw-bold">
                  {t("contact.messageLabel")} *
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  className="form-control"
                  placeholder={t("contact.messagePlaceholder")}
                  required
                />
              </div>

              {/* Honeypot */}
              <input type="text" name="website" style={{ display: "none" }} tabIndex={-1} autoComplete="off" />

              <div className="d-grid">
                <button type="submit" className="btn btn-outline-light fw-bold" disabled={isSubmitting}>
                  {isSubmitting ? t("contact.sending") : t("contact.send")}
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>

      {showSuccess && (
        <div
          onClick={() => setShowSuccess(false)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, padding: '1rem'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '12px', padding: '2rem',
              maxWidth: '380px', width: '100%', textAlign: 'center',
              boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
            }}
          >
            <div style={{
              width: '72px', height: '72px', borderRadius: '50%',
              background: '#28a745', display: 'flex', alignItems: 'center',
              justifyContent: 'center', margin: '0 auto 1rem'
            }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                <path d="M5 13l4 4L19 7" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h4 className="fw-bold mb-2" style={{ color: '#1D3EE3' }}>
              {t('contact.successTitle') || 'Sukses!'}
            </h4>
            <p className="mb-4" style={{ color: '#333' }}>
              {t('contact.success') || 'Mesazhi u dërgua me sukses!'}
            </p>
            <button
              type="button"
              className="btn btn-primary fw-bold px-4"
              onClick={() => setShowSuccess(false)}
              style={{ borderRadius: '8px' }}
            >
              {t('contact.successClose') || 'Në rregull'}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CONTACTUS;
